import { createTheme as createMuiTheme } from '@mui/material/styles';
import variants from './variants';
import typography from './typography';
import overrides from './overrides';
import breakpoints from './breakpoints';
import props from './props';
import shadows from './shadows';

const createCustomTheme = (name: string) => {
  let themeConfig = variants.find((variant) => variant.name === name);

  if (!themeConfig) {
    console.warn(new Error(`The theme ${name} is not valid`));
    themeConfig = variants[0];
  }

  return createMuiTheme(
    {
      spacing: 4,
      breakpoints: breakpoints,
      // TODO: Migrate overrides to MUI v7 components format
      // components: overrides,
      // props: props,
      typography: typography as any,
      palette: themeConfig.palette,
      components: {
        // MUI 9 default is theme.spacing(4.5), which is 18px with `spacing: 4`.
        // Keep the 56px MUI 7 rendered so list icons do not shift.
        MuiListItemIcon: { styleOverrides: { root: { minWidth: 56 } } },
      },
    },
    {
      name: themeConfig.name,
      header: themeConfig.header,
      footer: themeConfig.footer,
      sidebar: themeConfig.sidebar,
    },
  );
};

export default createCustomTheme;
